export default "__VITE_ASSET__MAeDaiH8__"